// apps/web/src/components/shell/transicao-pagina.tsx — Fase 17.8, Plano 22 (D-19; UI-SPEC U-28).
// Entrada discreta da página: 200 ms, opacity e translateY(4px -> 0). A chave da rota remonta o wrapper a cada troca de página; o CSS
// (shell-premium.css) usa fill-mode backwards, então nenhum transform fica depois da entrada. Movimento reduzido: nada anima.
import type { ReactElement, ReactNode } from 'react';
import type { ModoTransicao } from '../../lib/shell/transicao';

export interface TransicaoPaginaProps {
  readonly chave: string;
  readonly modo: ModoTransicao;
  readonly children: ReactNode;
}

export function TransicaoPagina({ chave, modo, children }: TransicaoPaginaProps): ReactElement {
  return (
    <div key={chave} className="transicao-pagina" data-transicao={modo} data-testid="transicao-pagina">
      {children}
    </div>
  );
}
